export const PROVIDER_REDIRECT_BASE = '/auth/login';
export const PROVIDER_REDIRECT_SUCCESS = `${PROVIDER_REDIRECT_BASE}/success`;
export const PROVIDER_REDIRECT_ERROR = `${PROVIDER_REDIRECT_BASE}/error`;

export default {
  PROVIDER_REDIRECT_BASE,
  PROVIDER_REDIRECT_SUCCESS,
  PROVIDER_REDIRECT_ERROR,
};
